import type { ReactNode } from 'react';
import { header, row, left, h1, sub } from './PageHeader.css';

interface PageHeaderProps {
  title: string;
  subtitle?: string;
  pill?: ReactNode;
  action?: ReactNode;
}

export function PageHeader({ title, subtitle, pill, action }: PageHeaderProps) {
  return (
    <header className={header}>
      <div className={row}>
        <div className={left}>
          <h1 className={h1}>{title}</h1>
          {pill}
        </div>
        {action}
      </div>
      {subtitle && <p className={sub}>{subtitle}</p>}
    </header>
  );
}
